import { Cryptocurrency, Exchange } from '../types'

export const cryptocurrencies: Cryptocurrency[] = [
  {
    id: 'bitcoin',
    name: 'Bitcoin',
    symbol: 'BTC',
    rank: 1,
    logo: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1.png',
    trustScore: 9.5,
    price: 92152.71,
    marketCap: 1839142946820,
    volume24h: 66634813625,
    change24h: 0.88,
    description:
      'Bitcoin is the first and most widely recognized cryptocurrency, created by Satoshi Nakamoto in 2009. It operates on a decentralized network using blockchain technology.',
    website: 'https://bitcoin.org',
    whitepaper: 'https://bitcoin.org/bitcoin.pdf',
    pros: [
      'Most established cryptocurrency',
      'Highest liquidity',
      'Wide merchant acceptance',
      'Strong security track record',
    ],
    cons: [
      'High transaction fees during peak times',
      'Slower transaction speeds',
      'Energy-intensive mining',
    ],
    reviews: [
      {
        id: '1',
        author: 'CryptoTrader2024',
        rating: 5,
        date: '2024-01-15',
        comment: 'The gold standard of crypto. Reliable and trusted.',
        verified: true,
      },
      {
        id: '2',
        author: 'InvestorJohn',
        rating: 4,
        date: '2024-01-10',
        comment: 'Great store of value but fees can be high.',
        verified: true,
      },
    ],
  },
  {
    id: 'ethereum',
    name: 'Ethereum',
    symbol: 'ETH',
    rank: 2,
    logo: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1027.png',
    trustScore: 9.3,
    price: 3148.96,
    marketCap: 380065210690,
    volume24h: 28846263202,
    change24h: 0.51,
    description:
      'Ethereum is a decentralized platform that enables smart contracts and decentralized applications (dApps) to be built and operated without downtime, fraud, or interference.',
    website: 'https://ethereum.org',
    pros: [
      'Smart contract functionality',
      'Large developer ecosystem',
      'Proof of Stake consensus',
      'NFT and DeFi leader',
    ],
    cons: [
      'Gas fees can be expensive',
      'Network congestion issues',
      'Complexity for beginners',
    ],
    reviews: [
      {
        id: '3',
        author: 'DeFiEnthusiast',
        rating: 5,
        date: '2024-01-14',
        comment: 'The backbone of DeFi. Incredible ecosystem.',
        verified: true,
      },
      {
        id: '4',
        author: 'SmartContractDev',
        rating: 5,
        date: '2024-01-12',
        comment: 'Best platform for building dApps.',
        verified: true,
      },
    ],
  },
  {
    id: 'xrp',
    name: 'XRP',
    symbol: 'XRP',
    rank: 3,
    logo: 'https://s2.coinmarketcap.com/static/img/coins/64x64/52.png',
    trustScore: 7.9,
    price: 2.12,
    marketCap: 127988531646,
    volume24h: 3274865565,
    change24h: 2.73,
    description:
      'XRP is a digital asset built for payments, offering fast and low-cost international money transfers.',
    website: 'https://ripple.com',
    pros: [
      'Fast settlement times',
      'Low transaction costs',
      'Banking partnerships',
      'High throughput',
    ],
    cons: [
      'Ongoing SEC lawsuit',
      'Centralization concerns',
      'Limited use cases outside payments',
    ],
    reviews: [
      {
        id: '8',
        author: 'BankingPro',
        rating: 4,
        date: '2024-01-08',
        comment: 'Great for cross-border payments.',
        verified: true,
      },
    ],
  },
  {
    id: 'binance-coin',
    name: 'BNB',
    symbol: 'BNB',
    rank: 4,
    logo: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1839.png',
    trustScore: 8.7,
    price: 902.75,
    marketCap: 124342519951,
    volume24h: 2071555686,
    change24h: 0.47,
    description:
      'Binance Coin is the native cryptocurrency of the Binance exchange, used for trading fee discounts and various utilities within the Binance ecosystem.',
    website: 'https://www.binance.com',
    pros: [
      'Trading fee discounts',
      'Strong exchange backing',
      'Growing ecosystem',
      'Regular token burns',
    ],
    cons: [
      'Centralized control',
      'Dependent on Binance success',
      'Regulatory scrutiny',
    ],
    reviews: [
      {
        id: '5',
        author: 'BinanceUser',
        rating: 4,
        date: '2024-01-13',
        comment: 'Great utility token for Binance users.',
        verified: true,
      },
    ],
  },
  {
    id: 'solana',
    name: 'Solana',
    symbol: 'SOL',
    rank: 5,
    logo: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5426.png',
    trustScore: 8.5,
    price: 141.42,
    marketCap: 79165482598,
    volume24h: 4758549606,
    change24h: 0.25,
    description:
      'Solana is a high-performance blockchain supporting builders around the world creating crypto apps that scale.',
    website: 'https://solana.com',
    pros: [
      'Extremely fast transactions',
      'Low fees',
      'Growing DeFi ecosystem',
      'Strong developer community',
    ],
    cons: [
      'Network outages in the past',
      'Centralization concerns',
      'Relatively newer platform',
    ],
    reviews: [
      {
        id: '6',
        author: 'SpeedTrader',
        rating: 5,
        date: '2024-01-11',
        comment: 'Lightning fast and cheap. Love it!',
        verified: true,
      },
    ],
  },
  {
    id: 'tron',
    name: 'TRON',
    symbol: 'TRX',
    rank: 6,
    logo: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1958.png',
    trustScore: 7.8,
    price: 0.283,
    marketCap: 26801383758,
    volume24h: 508807205,
    change24h: 1.46,
    description:
      'TRON is a decentralized platform that aims to build a free, global digital content entertainment system with distributed storage technology.',
    website: 'https://tron.network',
    pros: [
      'High throughput',
      'Low transaction fees',
      'Strong in Asia',
      'Active development',
    ],
    cons: [
      'Centralization concerns',
      'Controversial founder',
      'Limited DeFi adoption',
    ],
    reviews: [
      {
        id: '13',
        author: 'TronUser',
        rating: 4,
        date: '2024-01-09',
        comment: 'Fast and cheap transactions.',
        verified: true,
      },
    ],
  },
  {
    id: 'dogecoin',
    name: 'Dogecoin',
    symbol: 'DOGE',
    rank: 7,
    logo: 'https://s2.coinmarketcap.com/static/img/coins/64x64/74.png',
    trustScore: 7.2,
    price: 0.1486,
    marketCap: 24024400183,
    volume24h: 1241007232,
    change24h: 1.76,
    description:
      'Originally created as a joke, Dogecoin has become a popular cryptocurrency with a strong community.',
    website: 'https://dogecoin.com',
    pros: [
      'Strong community',
      'Low transaction fees',
      'Fast transactions',
      'Celebrity endorsements',
    ],
    cons: [
      'Unlimited supply',
      'Limited utility',
      'Meme-based volatility',
      'Less serious development',
    ],
    reviews: [
      {
        id: '10',
        author: 'MemeLord',
        rating: 3,
        date: '2024-01-06',
        comment: 'Fun community but risky investment.',
        verified: false,
      },
    ],
  },
  {
    id: 'cardano',
    name: 'Cardano',
    symbol: 'ADA',
    rank: 8,
    logo: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2010.png',
    trustScore: 8.4,
    price: 0.4432,
    marketCap: 15912382075,
    volume24h: 693291558,
    change24h: 0.12,
    description:
      'Cardano is a proof-of-stake blockchain platform founded on peer-reviewed research and developed through evidence-based methods.',
    website: 'https://cardano.org',
    pros: [
      'Academic research-based',
      'Energy efficient PoS',
      'Strong community',
      'Methodical development',
    ],
    cons: [
      'Slower development pace',
      'Limited dApp ecosystem',
      'Lower adoption than competitors',
    ],
    reviews: [
      {
        id: '7',
        author: 'AcademicInvestor',
        rating: 4,
        date: '2024-01-09',
        comment: 'Love the research-driven approach.',
        verified: true,
      },
    ],
  },
  {
    id: 'hyperliquid',
    name: 'Hyperliquid',
    symbol: 'HYPE',
    rank: 9,
    logo: 'https://s2.coinmarketcap.com/static/img/coins/64x64/32196.png',
    trustScore: 8.1,
    price: 34.06,
    marketCap: 11467956291,
    volume24h: 312972619,
    change24h: 0.57,
    description:
      'Hyperliquid is a high-performance decentralized exchange with an on-chain order book.',
    website: 'https://hyperliquid.xyz',
    pros: [
      'High performance',
      'On-chain order book',
      'Low fees',
      'Fast execution',
    ],
    cons: ['Newer platform', 'Limited track record', 'Smaller ecosystem'],
    reviews: [
      {
        id: '14',
        author: 'DeFiTrader',
        rating: 4,
        date: '2024-01-08',
        comment: 'Impressive DEX performance.',
        verified: true,
      },
    ],
  },
  {
    id: 'bitcoin-cash',
    name: 'Bitcoin Cash',
    symbol: 'BCH',
    rank: 10,
    logo: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1831.png',
    trustScore: 7.5,
    price: 572.82,
    marketCap: 11434915577,
    volume24h: 476123344,
    change24h: 3.85,
    description:
      'Bitcoin Cash is a peer-to-peer electronic cash system that aims to become sound global money with fast payments and low fees.',
    website: 'https://bitcoincash.org',
    pros: [
      'Larger block size',
      'Lower fees than Bitcoin',
      'Fast transactions',
      'Merchant adoption',
    ],
    cons: ['Less secure than Bitcoin', 'Smaller network', 'Controversial fork'],
    reviews: [
      {
        id: '15',
        author: 'BCHFan',
        rating: 4,
        date: '2024-01-07',
        comment: 'Better for payments than BTC.',
        verified: true,
      },
    ],
  },
  {
    id: 'chainlink',
    name: 'Chainlink',
    symbol: 'LINK',
    rank: 11,
    logo: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1975.png',
    trustScore: 8.6,
    price: 14.33,
    marketCap: 9989753512,
    volume24h: 811009307,
    change24h: 0.97,
    description:
      'Chainlink is a decentralized oracle network that enables smart contracts to securely interact with real-world data.',
    website: 'https://chain.link',
    pros: [
      'Essential infrastructure',
      'Wide adoption',
      'Strong partnerships',
      'Proven technology',
    ],
    cons: [
      'Token utility questions',
      'Competition emerging',
      'Complex tokenomics',
    ],
    reviews: [
      {
        id: '12',
        author: 'OracleFan',
        rating: 5,
        date: '2024-01-04',
        comment: 'Critical infrastructure for DeFi.',
        verified: true,
      },
    ],
  },
  {
    id: 'unus-sed-leo',
    name: 'UNUS SED LEO',
    symbol: 'LEO',
    rank: 12,
    logo: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3957.png',
    trustScore: 7.6,
    price: 9.58,
    marketCap: 8836373235,
    volume24h: 735410,
    change24h: 2.22,
    description: 'UNUS SED LEO is a utility token issued by Bitfinex exchange.',
    website: 'https://www.bitfinex.com',
    pros: ['Exchange backing', 'Token buybacks', 'Fee discounts'],
    cons: ['Centralized', 'Limited use cases', 'Exchange dependent'],
    reviews: [
      {
        id: '16',
        author: 'BitfinexUser',
        rating: 3,
        date: '2024-01-06',
        comment: 'Good for Bitfinex users.',
        verified: true,
      },
    ],
  },
  {
    id: 'stellar',
    name: 'Stellar',
    symbol: 'XLM',
    rank: 13,
    logo: 'https://s2.coinmarketcap.com/static/img/coins/64x64/512.png',
    trustScore: 8.0,
    price: 0.2518,
    marketCap: 8141414881,
    volume24h: 175392439,
    change24h: 2.57,
    description:
      'Stellar is an open network for storing and moving money that connects people to low-cost financial services.',
    website: 'https://stellar.org',
    pros: [
      'Fast transactions',
      'Low fees',
      'Cross-border focus',
      'Non-profit foundation',
    ],
    cons: ['Centralized development', 'Lower adoption', 'Competition from XRP'],
    reviews: [
      {
        id: '17',
        author: 'XLMHolder',
        rating: 4,
        date: '2024-01-05',
        comment: 'Great for remittances.',
        verified: true,
      },
    ],
  },
  {
    id: 'monero',
    name: 'Monero',
    symbol: 'XMR',
    rank: 14,
    logo: 'https://s2.coinmarketcap.com/static/img/coins/64x64/328.png',
    trustScore: 8.2,
    price: 404.29,
    marketCap: 7457835647,
    volume24h: 170365256,
    change24h: 0.96,
    description:
      'Monero is a privacy-focused cryptocurrency that uses ring signatures and stealth addresses to obscure transaction details.',
    website: 'https://getmonero.org',
    pros: [
      'Strong privacy',
      'Fungibility',
      'Active development',
      'ASIC resistant',
    ],
    cons: ['Regulatory scrutiny', 'Exchange delistings', 'Slower transactions'],
    reviews: [
      {
        id: '18',
        author: 'PrivacyAdvocate',
        rating: 5,
        date: '2024-01-04',
        comment: 'Best privacy coin available.',
        verified: true,
      },
    ],
  },
  {
    id: 'litecoin',
    name: 'Litecoin',
    symbol: 'LTC',
    rank: 15,
    logo: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2.png',
    trustScore: 8.1,
    price: 83.55,
    marketCap: 6399388765,
    volume24h: 529308148,
    change24h: 2.21,
    description:
      "Litecoin is a peer-to-peer cryptocurrency created as the silver to Bitcoin's gold, offering faster transaction times.",
    website: 'https://litecoin.org',
    pros: [
      'Fast transactions',
      'Low fees',
      'Proven track record',
      'Wide acceptance',
    ],
    cons: [
      'Less innovation',
      'Lower developer activity',
      'Competition from newer chains',
    ],
    reviews: [
      {
        id: '19',
        author: 'LTCFan',
        rating: 4,
        date: '2024-01-03',
        comment: 'Reliable and fast payments.',
        verified: true,
      },
    ],
  },
  {
    id: 'avalanche',
    name: 'Avalanche',
    symbol: 'AVAX',
    rank: 16,
    logo: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5805.png',
    trustScore: 8.3,
    price: 14.53,
    marketCap: 6235518549,
    volume24h: 506016834,
    change24h: 0.87,
    description:
      'Avalanche is a layer one blockchain that functions as a platform for decentralized applications and custom blockchain networks.',
    website: 'https://www.avax.network',
    pros: [
      'High throughput',
      'Low latency',
      'Ethereum compatibility',
      'Subnet architecture',
    ],
    cons: [
      'Newer platform',
      'Validator requirements',
      'Competition from established chains',
    ],
    reviews: [
      {
        id: '11',
        author: 'DeFiBuilder',
        rating: 5,
        date: '2024-01-05',
        comment: 'Impressive speed and low fees.',
        verified: true,
      },
    ],
  },
  {
    id: 'sui',
    name: 'Sui',
    symbol: 'SUI',
    rank: 17,
    logo: 'https://s2.coinmarketcap.com/static/img/coins/64x64/20947.png',
    trustScore: 7.9,
    price: 1.66,
    marketCap: 6203425526,
    volume24h: 866723808,
    change24h: 1.89,
    description:
      'Sui is a layer-1 blockchain designed to support high-performance decentralized applications.',
    website: 'https://sui.io',
    pros: [
      'High performance',
      'Parallel execution',
      'Move programming language',
      'Low latency',
    ],
    cons: ['Newer platform', 'Smaller ecosystem', 'Unproven at scale'],
    reviews: [
      {
        id: '20',
        author: 'SuiDev',
        rating: 4,
        date: '2024-01-02',
        comment: 'Promising new L1.',
        verified: true,
      },
    ],
  },
  {
    id: 'hedera',
    name: 'Hedera',
    symbol: 'HBAR',
    rank: 18,
    logo: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4642.png',
    trustScore: 7.8,
    price: 0.1404,
    marketCap: 5963761768,
    volume24h: 229846256,
    change24h: 3.97,
    description:
      'Hedera is a public distributed ledger technology that uses hashgraph consensus.',
    website: 'https://hedera.com',
    pros: [
      'Fast finality',
      'Low fees',
      'Enterprise adoption',
      'Energy efficient',
    ],
    cons: ['Centralized governance', 'Permissioned validators', 'Limited DeFi'],
    reviews: [
      {
        id: '21',
        author: 'HBARHolder',
        rating: 4,
        date: '2024-01-01',
        comment: 'Great for enterprise use.',
        verified: true,
      },
    ],
  },
  {
    id: 'zcash',
    name: 'Zcash',
    symbol: 'ZEC',
    rank: 19,
    logo: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1437.png',
    trustScore: 7.7,
    price: 363.54,
    marketCap: 5969939145,
    volume24h: 1227927165,
    change24h: 3.42,
    description:
      'Zcash is a privacy-focused cryptocurrency that uses zero-knowledge proofs to shield transaction data.',
    website: 'https://z.cash',
    pros: [
      'Strong privacy',
      'Optional transparency',
      'Academic backing',
      'Proven cryptography',
    ],
    cons: [
      'Regulatory concerns',
      'Lower adoption',
      'Trusted setup controversy',
    ],
    reviews: [
      {
        id: '22',
        author: 'ZECUser',
        rating: 4,
        date: '2023-12-31',
        comment: 'Excellent privacy features.',
        verified: true,
      },
    ],
  },
  {
    id: 'shiba-inu',
    name: 'Shiba Inu',
    symbol: 'SHIB',
    rank: 20,
    logo: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5994.png',
    trustScore: 6.8,
    price: 0.00000882,
    marketCap: 5138094518,
    volume24h: 156878122,
    change24h: 6.93,
    description:
      'Shiba Inu is a meme token that has evolved into a decentralized ecosystem.',
    website: 'https://shibatoken.com',
    pros: [
      'Strong community',
      'Growing ecosystem',
      'Multiple tokens',
      'High liquidity',
    ],
    cons: [
      'Meme coin volatility',
      'Unclear utility',
      'High supply',
      'Speculative',
    ],
    reviews: [
      {
        id: '23',
        author: 'ShibArmy',
        rating: 3,
        date: '2023-12-30',
        comment: 'Fun community but very risky.',
        verified: false,
      },
    ],
  },
  {
    id: 'world-liberty-financial',
    name: 'World Liberty Financial',
    symbol: 'WLFI',
    rank: 21,
    logo: 'https://s2.coinmarketcap.com/static/img/coins/64x64/33251.png',
    trustScore: 7.0,
    price: 0.1535,
    marketCap: 4103806823,
    volume24h: 120479527,
    change24h: 3.56,
    description:
      'World Liberty Financial is a DeFi platform backed by the Trump family.',
    website: 'https://worldlibertyfi.com',
    pros: ['High-profile backing', 'DeFi focus', 'Growing interest'],
    cons: ['Newer project', 'Controversial backing', 'Unproven platform'],
    reviews: [
      {
        id: '24',
        author: 'DeFiWatcher',
        rating: 3,
        date: '2023-12-29',
        comment: 'Interesting but risky.',
        verified: false,
      },
    ],
  },
  {
    id: 'cronos',
    name: 'Cronos',
    symbol: 'CRO',
    rank: 22,
    logo: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3635.png',
    trustScore: 7.5,
    price: 0.1074,
    marketCap: 4012680201,
    volume24h: 16352130,
    change24h: 2.21,
    description: 'Cronos is the EVM-compatible blockchain built by Crypto.com.',
    website: 'https://cronos.org',
    pros: ['Exchange backing', 'EVM compatible', 'Growing DeFi', 'Low fees'],
    cons: ['Centralized', 'Exchange dependent', 'Smaller ecosystem'],
    reviews: [
      {
        id: '25',
        author: 'CROUser',
        rating: 4,
        date: '2023-12-28',
        comment: 'Good for Crypto.com users.',
        verified: true,
      },
    ],
  },
  {
    id: 'toncoin',
    name: 'Toncoin',
    symbol: 'TON',
    rank: 23,
    logo: 'https://s2.coinmarketcap.com/static/img/coins/64x64/11419.png',
    trustScore: 7.6,
    price: 1.59,
    marketCap: 3905685886,
    volume24h: 96399381,
    change24h: 1.41,
    description:
      'Toncoin is the native cryptocurrency of The Open Network, originally developed by Telegram.',
    website: 'https://ton.org',
    pros: [
      'Telegram integration',
      'Fast transactions',
      'Scalable',
      'Growing adoption',
    ],
    cons: ['Complex technology', 'Regulatory history', 'Smaller ecosystem'],
    reviews: [
      {
        id: '26',
        author: 'TONFan',
        rating: 4,
        date: '2023-12-27',
        comment: 'Telegram integration is powerful.',
        verified: true,
      },
    ],
  },
  {
    id: 'polkadot',
    name: 'Polkadot',
    symbol: 'DOT',
    rank: 24,
    logo: 'https://s2.coinmarketcap.com/static/cloud/img/logo/polkadot/Polkadot_Logo_Animation_64x64.gif',
    trustScore: 8.2,
    price: 2.29,
    marketCap: 3776420503,
    volume24h: 194124694,
    change24h: 1.15,
    description:
      'Polkadot enables cross-blockchain transfers of any type of data or asset, not just tokens.',
    website: 'https://polkadot.network',
    pros: [
      'Interoperability focus',
      'Parachain architecture',
      'Strong technical team',
      'Governance features',
    ],
    cons: [
      'Complex technology',
      'Competition from other chains',
      'Parachain auction costs',
    ],
    reviews: [
      {
        id: '9',
        author: 'InteropFan',
        rating: 5,
        date: '2024-01-07',
        comment: 'The future of blockchain interoperability.',
        verified: true,
      },
    ],
  },
  {
    id: 'uniswap',
    name: 'Uniswap',
    symbol: 'UNI',
    rank: 25,
    logo: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7083.png',
    trustScore: 8.4,
    price: 5.94,
    marketCap: 3745056442,
    volume24h: 269049290,
    change24h: 1.58,
    description:
      'Uniswap is a leading decentralized exchange protocol on Ethereum.',
    website: 'https://uniswap.org',
    pros: [
      'Leading DEX',
      'High liquidity',
      'Proven protocol',
      'Strong governance',
    ],
    cons: ['High gas fees', 'Competition', 'Regulatory uncertainty'],
    reviews: [
      {
        id: '27',
        author: 'DeFiUser',
        rating: 5,
        date: '2023-12-26',
        comment: 'Best DEX experience.',
        verified: true,
      },
    ],
  },
  {
    id: 'mantle',
    name: 'Mantle',
    symbol: 'MNT',
    rank: 26,
    logo: 'https://s2.coinmarketcap.com/static/img/coins/64x64/27075.png',
    trustScore: 7.7,
    price: 1.07,
    marketCap: 3484805570,
    volume24h: 128883165,
    change24h: 0.13,
    description: 'Mantle is an Ethereum layer-2 scaling solution.',
    website: 'https://mantle.xyz',
    pros: [
      'Layer-2 scaling',
      'Low fees',
      'EVM compatible',
      'Growing ecosystem',
    ],
    cons: ['Newer platform', 'Centralization concerns', 'Competition'],
    reviews: [
      {
        id: '28',
        author: 'L2User',
        rating: 4,
        date: '2023-12-25',
        comment: 'Good L2 solution.',
        verified: true,
      },
    ],
  },
  {
    id: 'bittensor',
    name: 'Bittensor',
    symbol: 'TAO',
    rank: 27,
    logo: 'https://s2.coinmarketcap.com/static/img/coins/64x64/22974.png',
    trustScore: 7.9,
    price: 295.46,
    marketCap: 3082094070,
    volume24h: 198986254,
    change24h: 2.54,
    description: 'Bittensor is a decentralized machine learning network.',
    website: 'https://bittensor.com',
    pros: [
      'AI focus',
      'Innovative concept',
      'Growing interest',
      'Unique use case',
    ],
    cons: ['Complex technology', 'Newer project', 'Unproven at scale'],
    reviews: [
      {
        id: '29',
        author: 'AIEnthusiast',
        rating: 4,
        date: '2023-12-24',
        comment: 'Fascinating AI project.',
        verified: true,
      },
    ],
  },
  {
    id: 'aave',
    name: 'Aave',
    symbol: 'AAVE',
    rank: 28,
    logo: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7278.png',
    trustScore: 8.5,
    price: 192.32,
    marketCap: 2937897120,
    volume24h: 240488272,
    change24h: 0.72,
    description: 'Aave is a decentralized lending and borrowing protocol.',
    website: 'https://aave.com',
    pros: [
      'Leading DeFi protocol',
      'Proven track record',
      'Innovation',
      'Strong governance',
    ],
    cons: ['Smart contract risk', 'Competition', 'Regulatory uncertainty'],
    reviews: [
      {
        id: '30',
        author: 'DeFiLender',
        rating: 5,
        date: '2023-12-23',
        comment: 'Best lending protocol.',
        verified: true,
      },
    ],
  },
  {
    id: 'canton',
    name: 'Canton',
    symbol: 'CC',
    rank: 29,
    logo: 'https://s2.coinmarketcap.com/static/img/coins/64x64/37263.png',
    trustScore: 7.2,
    price: 0.07327,
    marketCap: 2618347022,
    volume24h: 16117183,
    change24h: 8.34,
    description: 'Canton is a blockchain network for institutional finance.',
    website: 'https://canton.network',
    pros: ['Enterprise focus', 'Privacy features', 'Institutional backing'],
    cons: ['Newer project', 'Limited adoption', 'Permissioned'],
    reviews: [
      {
        id: '31',
        author: 'InstitutionalUser',
        rating: 3,
        date: '2023-12-22',
        comment: 'Interesting for enterprise.',
        verified: false,
      },
    ],
  },
  {
    id: 'bitget-token',
    name: 'Bitget Token',
    symbol: 'BGB',
    rank: 30,
    logo: 'https://s2.coinmarketcap.com/static/img/coins/64x64/11092.png',
    trustScore: 7.4,
    price: 3.55,
    marketCap: 2474935456,
    volume24h: 64136133,
    change24h: 1.19,
    description: 'Bitget Token is the native token of Bitget exchange.',
    website: 'https://www.bitget.com',
    pros: ['Exchange backing', 'Trading benefits', 'Growing platform'],
    cons: ['Centralized', 'Exchange dependent', 'Limited utility'],
    reviews: [
      {
        id: '32',
        author: 'BitgetUser',
        rating: 3,
        date: '2023-12-21',
        comment: 'Good for Bitget users.',
        verified: true,
      },
    ],
  },
  {
    id: 'aster',
    name: 'Aster',
    symbol: 'ASTER',
    rank: 31,
    logo: 'https://s2.coinmarketcap.com/static/img/coins/64x64/36341.png',
    trustScore: 7.3,
    price: 1.04,
    marketCap: 2476117832,
    volume24h: 255447651,
    change24h: 1.53,
    description:
      'Aster is a blockchain platform for decentralized applications.',
    website: 'https://aster.network',
    pros: ['Multi-chain support', 'Developer friendly', 'Growing ecosystem'],
    cons: ['Newer platform', 'Smaller community', 'Competition'],
    reviews: [
      {
        id: '33',
        author: 'AsterDev',
        rating: 4,
        date: '2023-12-20',
        comment: 'Good developer experience.',
        verified: true,
      },
    ],
  },
  {
    id: 'near-protocol',
    name: 'NEAR Protocol',
    symbol: 'NEAR',
    rank: 32,
    logo: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6535.png',
    trustScore: 8.0,
    price: 1.79,
    marketCap: 2305711983,
    volume24h: 195361877,
    change24h: 0.56,
    description:
      'NEAR is a sharded, proof-of-stake blockchain designed to be developer and user-friendly.',
    website: 'https://near.org',
    pros: ['Developer friendly', 'Sharding', 'Low fees', 'Fast finality'],
    cons: ['Smaller ecosystem', 'Competition', 'Centralization concerns'],
    reviews: [
      {
        id: '34',
        author: 'NEARDev',
        rating: 4,
        date: '2023-12-19',
        comment: 'Great for developers.',
        verified: true,
      },
    ],
  },
  {
    id: 'okb',
    name: 'OKB',
    symbol: 'OKB',
    rank: 33,
    logo: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3897.png',
    trustScore: 7.5,
    price: 106.62,
    marketCap: 2239057636,
    volume24h: 38811240,
    change24h: 0.74,
    description: 'OKB is the native token of OKX exchange.',
    website: 'https://www.okx.com',
    pros: ['Exchange backing', 'Trading benefits', 'Established platform'],
    cons: ['Centralized', 'Exchange dependent', 'Regulatory risks'],
    reviews: [
      {
        id: '35',
        author: 'OKXUser',
        rating: 4,
        date: '2023-12-18',
        comment: 'Useful for OKX trading.',
        verified: true,
      },
    ],
  },
  {
    id: 'ethena',
    name: 'Ethena',
    symbol: 'ENA',
    rank: 34,
    logo: 'https://s2.coinmarketcap.com/static/img/coins/64x64/30171.png',
    trustScore: 7.6,
    price: 0.2871,
    marketCap: 2131684958,
    volume24h: 276705917,
    change24h: 1.78,
    description: 'Ethena is a synthetic dollar protocol.',
    website: 'https://ethena.fi',
    pros: ['Innovative stablecoin', 'DeFi integration', 'Yield generation'],
    cons: ['Newer protocol', 'Complex mechanism', 'Regulatory uncertainty'],
    reviews: [
      {
        id: '36',
        author: 'StablecoinUser',
        rating: 3,
        date: '2023-12-17',
        comment: 'Interesting approach.',
        verified: false,
      },
    ],
  },
  {
    id: 'ethereum-classic',
    name: 'Ethereum Classic',
    symbol: 'ETC',
    rank: 35,
    logo: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1321.png',
    trustScore: 7.3,
    price: 13.77,
    marketCap: 2129256916,
    volume24h: 75299366,
    change24h: 1.97,
    description:
      'Ethereum Classic is the original Ethereum blockchain that maintained the original chain after The DAO hack.',
    website: 'https://ethereumclassic.org',
    pros: ['Immutability', 'Proven technology', 'Mining support'],
    cons: ['51% attack history', 'Lower development', 'Smaller ecosystem'],
    reviews: [
      {
        id: '37',
        author: 'ETCMiner',
        rating: 3,
        date: '2023-12-16',
        comment: 'Good for mining.',
        verified: true,
      },
    ],
  },
  {
    id: 'pepe',
    name: 'Pepe',
    symbol: 'PEPE',
    rank: 36,
    logo: 'https://s2.coinmarketcap.com/static/img/coins/64x64/24478.png',
    trustScore: 6.5,
    price: 0.00000001095,
    marketCap: 2017152958,
    volume24h: 383209262,
    change24h: 0.31,
    description:
      'Pepe is a meme coin based on the popular Pepe the Frog internet meme.',
    website: 'https://pepe.vip',
    pros: ['Strong community', 'High liquidity', 'Meme appeal'],
    cons: ['No utility', 'Highly speculative', 'Meme volatility'],
    reviews: [
      {
        id: '38',
        author: 'MemeCoinTrader',
        rating: 2,
        date: '2023-12-15',
        comment: 'Pure speculation.',
        verified: false,
      },
    ],
  },
  {
    id: 'internet-computer',
    name: 'Internet Computer',
    symbol: 'ICP',
    rank: 37,
    logo: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8916.png',
    trustScore: 7.7,
    price: 3.68,
    marketCap: 1996475410,
    volume24h: 114160447,
    change24h: 0.04,
    description:
      'Internet Computer is a blockchain that aims to extend the internet with compute capabilities.',
    website: 'https://internetcomputer.org',
    pros: ['Ambitious vision', 'Fast finality', 'Web-speed', 'Innovative'],
    cons: [
      'Controversial launch',
      'Centralization concerns',
      'Complex technology',
    ],
    reviews: [
      {
        id: '39',
        author: 'ICPDev',
        rating: 3,
        date: '2023-12-14',
        comment: 'Interesting but controversial.',
        verified: true,
      },
    ],
  },
  {
    id: 'pi',
    name: 'Pi',
    symbol: 'PI',
    rank: 38,
    logo: 'https://s2.coinmarketcap.com/static/img/coins/64x64/35697.png',
    trustScore: 6.9,
    price: 0.2313,
    marketCap: 1930608225,
    volume24h: 16495262,
    change24h: 0.42,
    description:
      'Pi Network is a mobile-first cryptocurrency that can be mined on smartphones.',
    website: 'https://minepi.com',
    pros: ['Mobile mining', 'Large user base', 'Accessible'],
    cons: ['Not fully launched', 'Centralized', 'Unclear tokenomics'],
    reviews: [
      {
        id: '40',
        author: 'PiMiner',
        rating: 3,
        date: '2023-12-13',
        comment: 'Waiting for mainnet.',
        verified: false,
      },
    ],
  },
  {
    id: 'ondo',
    name: 'Ondo',
    symbol: 'ONDO',
    rank: 39,
    logo: 'https://s2.coinmarketcap.com/static/img/coins/64x64/21159.png',
    trustScore: 7.8,
    price: 0.4923,
    marketCap: 1555287658,
    volume24h: 67460463,
    change24h: 3.05,
    description:
      'Ondo Finance provides institutional-grade financial products on-chain.',
    website: 'https://ondo.finance',
    pros: ['RWA focus', 'Institutional grade', 'Compliance focused'],
    cons: ['Newer protocol', 'Regulatory dependent', 'Limited adoption'],
    reviews: [
      {
        id: '41',
        author: 'RWAInvestor',
        rating: 4,
        date: '2023-12-12',
        comment: 'Interesting RWA approach.',
        verified: true,
      },
    ],
  },
  {
    id: 'worldcoin',
    name: 'Worldcoin',
    symbol: 'WLD',
    rank: 40,
    logo: 'https://s2.coinmarketcap.com/static/img/coins/64x64/13502.png',
    trustScore: 7.1,
    price: 0.6309,
    marketCap: 1504536158,
    volume24h: 91998902,
    change24h: 0.39,
    description:
      'Worldcoin aims to create a global identity and financial network.',
    website: 'https://worldcoin.org',
    pros: ['Ambitious vision', 'Sam Altman backing', 'UBI focus'],
    cons: ['Privacy concerns', 'Biometric data', 'Controversial'],
    reviews: [
      {
        id: '42',
        author: 'WLDUser',
        rating: 3,
        date: '2023-12-11',
        comment: 'Interesting but concerning.',
        verified: false,
      },
    ],
  },
  {
    id: 'kaspa',
    name: 'Kaspa',
    symbol: 'KAS',
    rank: 41,
    logo: 'https://s2.coinmarketcap.com/static/img/coins/64x64/20396.png',
    trustScore: 7.6,
    price: 0.05551,
    marketCap: 1498049154,
    volume24h: 30731334,
    change24h: 1.06,
    description:
      'Kaspa is a proof-of-work cryptocurrency implementing the GHOSTDAG protocol.',
    website: 'https://kaspa.org',
    pros: ['Fast block times', 'Scalable', 'Fair launch', 'Active development'],
    cons: ['Newer project', 'Smaller ecosystem', 'Mining competition'],
    reviews: [
      {
        id: '43',
        author: 'KASMiner',
        rating: 4,
        date: '2023-12-10',
        comment: 'Great mining experience.',
        verified: true,
      },
    ],
  },
  {
    id: 'aptos',
    name: 'Aptos',
    symbol: 'APT',
    rank: 42,
    logo: 'https://s2.coinmarketcap.com/static/img/coins/64x64/21794.png',
    trustScore: 7.9,
    price: 1.97,
    marketCap: 1453197017,
    volume24h: 94778605,
    change24h: 1.18,
    description:
      'Aptos is a layer-1 blockchain built by former Meta engineers using the Move programming language.',
    website: 'https://aptoslabs.com',
    pros: ['Strong team', 'Move language', 'High performance', 'VC backing'],
    cons: ['Centralized launch', 'Token unlock concerns', 'Competition'],
    reviews: [
      {
        id: '44',
        author: 'APTDev',
        rating: 4,
        date: '2023-12-09',
        comment: 'Solid technology.',
        verified: true,
      },
    ],
  },
  {
    id: 'memecore',
    name: 'MemeCore',
    symbol: 'M',
    rank: 43,
    logo: 'https://s2.coinmarketcap.com/static/img/coins/64x64/35491.png',
    trustScore: 6.7,
    price: 1.32,
    marketCap: 1379933775,
    volume24h: 27822158,
    change24h: 1.77,
    description: 'MemeCore is a meme coin platform.',
    website: 'https://memecore.com',
    pros: ['Meme community', 'Platform approach'],
    cons: ['Speculative', 'Newer project', 'Unclear utility'],
    reviews: [
      {
        id: '45',
        author: 'MemeTrader',
        rating: 2,
        date: '2023-12-08',
        comment: 'High risk meme coin.',
        verified: false,
      },
    ],
  },
  {
    id: 'kucoin-token',
    name: 'KuCoin Token',
    symbol: 'KCS',
    rank: 44,
    logo: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2087.png',
    trustScore: 7.6,
    price: 10.61,
    marketCap: 1377080387,
    volume24h: 8341088,
    change24h: 2.74,
    description: 'KuCoin Token is the native token of KuCoin exchange.',
    website: 'https://www.kucoin.com',
    pros: ['Exchange backing', 'Trading benefits', 'Established platform'],
    cons: ['Centralized', 'Exchange dependent', 'Regulatory risks'],
    reviews: [
      {
        id: '46',
        author: 'KuCoinUser',
        rating: 4,
        date: '2023-12-07',
        comment: 'Good for KuCoin users.',
        verified: true,
      },
    ],
  },
  {
    id: 'polygon',
    name: 'Polygon',
    symbol: 'POL',
    rank: 45,
    logo: 'https://s2.coinmarketcap.com/static/img/coins/64x64/28321.png',
    trustScore: 8.1,
    price: 0.1253,
    marketCap: 1322466242,
    volume24h: 82643229,
    change24h: 1.68,
    description:
      'Polygon is a protocol for building and connecting Ethereum-compatible blockchain networks.',
    website: 'https://polygon.technology',
    pros: [
      'Ethereum scaling',
      'Low fees',
      'Growing ecosystem',
      'Strong partnerships',
    ],
    cons: ['Centralization concerns', 'Competition', 'Bridge risks'],
    reviews: [
      {
        id: '47',
        author: 'POLUser',
        rating: 4,
        date: '2023-12-06',
        comment: 'Great for scaling Ethereum.',
        verified: true,
      },
    ],
  },
  {
    id: 'sky',
    name: 'Sky',
    symbol: 'SKY',
    rank: 46,
    logo: 'https://s2.coinmarketcap.com/static/img/coins/64x64/33038.png',
    trustScore: 7.4,
    price: 0.05626,
    marketCap: 1289343362,
    volume24h: 27000734,
    change24h: 2.86,
    description: 'Sky (formerly MakerDAO) is a decentralized credit platform.',
    website: 'https://sky.money',
    pros: ['Established protocol', 'DAI stablecoin', 'Strong governance'],
    cons: ['Complex system', 'Rebranding confusion', 'Competition'],
    reviews: [
      {
        id: '48',
        author: 'DeFiUser',
        rating: 4,
        date: '2023-12-05',
        comment: 'Solid DeFi protocol.',
        verified: true,
      },
    ],
  },
  {
    id: 'algorand',
    name: 'Algorand',
    symbol: 'ALGO',
    rank: 47,
    logo: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4030.png',
    trustScore: 7.9,
    price: 0.14,
    marketCap: 1234361037,
    volume24h: 38874989,
    change24h: 0.9,
    description:
      'Algorand is a pure proof-of-stake blockchain designed for speed and decentralization.',
    website: 'https://algorand.com',
    pros: ['Fast finality', 'Carbon negative', 'Academic backing', 'Pure PoS'],
    cons: ['Centralized foundation', 'Lower adoption', 'Competition'],
    reviews: [
      {
        id: '49',
        author: 'ALGOHolder',
        rating: 4,
        date: '2023-12-04',
        comment: 'Great technology.',
        verified: true,
      },
    ],
  },
  {
    id: 'arbitrum',
    name: 'Arbitrum',
    symbol: 'ARB',
    rank: 48,
    logo: 'https://s2.coinmarketcap.com/static/img/coins/64x64/11841.png',
    trustScore: 8.2,
    price: 0.2179,
    marketCap: 1224232145,
    volume24h: 120401979,
    change24h: 0.8,
    description:
      'Arbitrum is a layer-2 scaling solution for Ethereum using optimistic rollups.',
    website: 'https://arbitrum.io',
    pros: ['Ethereum scaling', 'Low fees', 'EVM compatible', 'Growing DeFi'],
    cons: ['Centralized sequencer', 'Competition', 'Withdrawal delays'],
    reviews: [
      {
        id: '50',
        author: 'ARBUser',
        rating: 4,
        date: '2023-12-03',
        comment: 'Best L2 experience.',
        verified: true,
      },
    ],
  },
  {
    id: 'trump',
    name: 'OFFICIAL TRUMP',
    symbol: 'TRUMP',
    rank: 49,
    logo: 'https://s2.coinmarketcap.com/static/img/coins/64x64/35336.png',
    trustScore: 6.5,
    price: 6.04,
    marketCap: 1208397236,
    volume24h: 204233573,
    change24h: 0.17,
    description: 'Official Trump is a meme coin associated with Donald Trump.',
    website: 'https://gettrump.com',
    pros: ['High-profile association', 'Strong community'],
    cons: ['Highly speculative', 'Political controversy', 'No utility'],
    reviews: [
      {
        id: '51',
        author: 'TrumpSupporter',
        rating: 2,
        date: '2023-12-02',
        comment: 'Pure speculation.',
        verified: false,
      },
    ],
  },
  {
    id: 'vechain',
    name: 'VeChain',
    symbol: 'VET',
    rank: 50,
    logo: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3077.png',
    trustScore: 7.7,
    price: 0.01322,
    marketCap: 1136850754,
    volume24h: 26965027,
    change24h: 2.1,
    description:
      'VeChain is a blockchain platform focused on supply chain management and business processes.',
    website: 'https://vechain.org',
    pros: [
      'Enterprise focus',
      'Real-world adoption',
      'Strong partnerships',
      'Dual-token model',
    ],
    cons: ['Centralized', 'Lower DeFi adoption', 'Authority node system'],
    reviews: [
      {
        id: '52',
        author: 'VETHolder',
        rating: 4,
        date: '2023-12-01',
        comment: 'Great for supply chain.',
        verified: true,
      },
    ],
  },
  {
    id: 'filecoin',
    name: 'Filecoin',
    symbol: 'FIL',
    rank: 51,
    logo: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2280.png',
    trustScore: 7.8,
    price: 1.56,
    marketCap: 1128813187,
    volume24h: 137744744,
    change24h: 1.04,
    description:
      "Filecoin is a decentralized storage network designed to store humanity's most important information.",
    website: 'https://filecoin.io',
    pros: [
      'Decentralized storage',
      'Strong team',
      'Real utility',
      'Growing adoption',
    ],
    cons: ['Complex economics', 'Competition', 'High barriers to entry'],
    reviews: [
      {
        id: '53',
        author: 'FILMiner',
        rating: 4,
        date: '2023-11-30',
        comment: 'Solid storage solution.',
        verified: true,
      },
    ],
  },
  {
    id: 'quant',
    name: 'Quant',
    symbol: 'QNT',
    rank: 52,
    logo: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3155.png',
    trustScore: 7.9,
    price: 93.26,
    marketCap: 1126018871,
    volume24h: 26134973,
    change24h: 1.28,
    description:
      'Quant connects blockchains and networks globally without reducing efficiency and interoperability.',
    website: 'https://quant.network',
    pros: [
      'Interoperability',
      'Enterprise focus',
      'Strong partnerships',
      'Overledger technology',
    ],
    cons: ['Centralized', 'High token price', 'Limited supply'],
    reviews: [
      {
        id: '54',
        author: 'QNTInvestor',
        rating: 4,
        date: '2023-11-29',
        comment: 'Underrated project.',
        verified: true,
      },
    ],
  },
  {
    id: 'cosmos',
    name: 'Cosmos',
    symbol: 'ATOM',
    rank: 53,
    logo: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3794.png',
    trustScore: 8.0,
    price: 2.32,
    marketCap: 1120419427,
    volume24h: 53461870,
    change24h: 1.34,
    description:
      'Cosmos is a decentralized network of independent blockchains that can scale and interoperate.',
    website: 'https://cosmos.network',
    pros: ['Interoperability', 'IBC protocol', 'Growing ecosystem', 'Modular'],
    cons: ['Complex technology', 'Token value capture', 'Competition'],
    reviews: [
      {
        id: '55',
        author: 'ATOMHolder',
        rating: 4,
        date: '2023-11-28',
        comment: 'Internet of blockchains.',
        verified: true,
      },
    ],
  },
  {
    id: 'pump-fun',
    name: 'Pump.fun',
    symbol: 'PUMP',
    rank: 54,
    logo: 'https://s2.coinmarketcap.com/static/img/coins/64x64/36507.png',
    trustScore: 6.8,
    price: 0.003131,
    marketCap: 1108424146,
    volume24h: 178179395,
    change24h: 1.14,
    description: 'Pump.fun is a meme coin launchpad platform.',
    website: 'https://pump.fun',
    pros: ['Platform utility', 'Growing usage', 'Meme coin focus'],
    cons: ['Speculative', 'Regulatory risk', 'Platform dependent'],
    reviews: [
      {
        id: '56',
        author: 'MemeTrader',
        rating: 3,
        date: '2023-11-27',
        comment: 'Interesting platform.',
        verified: false,
      },
    ],
  },
  {
    id: 'flare',
    name: 'Flare',
    symbol: 'FLR',
    rank: 55,
    logo: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7950.png',
    trustScore: 7.5,
    price: 0.01365,
    marketCap: 1094598453,
    volume24h: 6901044,
    change24h: 0.15,
    description: 'Flare is a blockchain for data that connects everything.',
    website: 'https://flare.network',
    pros: ['Data focus', 'EVM compatible', 'State connector', 'FAssets'],
    cons: ['Newer platform', 'Complex technology', 'Adoption challenges'],
    reviews: [
      {
        id: '57',
        author: 'FLRUser',
        rating: 3,
        date: '2023-11-26',
        comment: 'Interesting data approach.',
        verified: true,
      },
    ],
  },
  {
    id: 'xdc-network',
    name: 'XDC Network',
    symbol: 'XDC',
    rank: 56,
    logo: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2634.png',
    trustScore: 7.6,
    price: 0.0503,
    marketCap: 931695387,
    volume24h: 35087800,
    change24h: 2.19,
    description:
      'XDC Network is an enterprise-ready hybrid blockchain for global trade and finance.',
    website: 'https://xdc.org',
    pros: ['Enterprise focus', 'Trade finance', 'Fast finality', 'Low fees'],
    cons: ['Lower awareness', 'Smaller ecosystem', 'Centralization'],
    reviews: [
      {
        id: '58',
        author: 'XDCUser',
        rating: 4,
        date: '2023-11-25',
        comment: 'Good for trade finance.',
        verified: true,
      },
    ],
  },
  {
    id: 'render',
    name: 'Render',
    symbol: 'RENDER',
    rank: 57,
    logo: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5690.png',
    trustScore: 7.7,
    price: 1.73,
    marketCap: 898064284,
    volume24h: 32916550,
    change24h: 1.19,
    description: 'Render Network is a distributed GPU rendering platform.',
    website: 'https://rendernetwork.com',
    pros: [
      'Real utility',
      'GPU rendering',
      'Growing demand',
      'Strong use case',
    ],
    cons: ['Niche market', 'Competition', 'Technical complexity'],
    reviews: [
      {
        id: '59',
        author: 'RenderUser',
        rating: 4,
        date: '2023-11-24',
        comment: 'Great for 3D rendering.',
        verified: true,
      },
    ],
  },
  {
    id: 'sei',
    name: 'Sei',
    symbol: 'SEI',
    rank: 58,
    logo: 'https://s2.coinmarketcap.com/static/img/coins/64x64/23149.png',
    trustScore: 7.6,
    price: 0.1376,
    marketCap: 876539727,
    volume24h: 70496086,
    change24h: 0.62,
    description: 'Sei is a layer-1 blockchain optimized for trading.',
    website: 'https://sei.io',
    pros: [
      'Trading optimized',
      'Fast finality',
      'Parallel execution',
      'Growing DeFi',
    ],
    cons: ['Newer platform', 'Smaller ecosystem', 'Competition'],
    reviews: [
      {
        id: '60',
        author: 'SEITrader',
        rating: 4,
        date: '2023-11-23',
        comment: 'Fast trading experience.',
        verified: true,
      },
    ],
  },
  {
    id: 'gatetoken',
    name: 'GateToken',
    symbol: 'GT',
    rank: 59,
    logo: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4269.png',
    trustScore: 7.4,
    price: 10.35,
    marketCap: 831631140,
    volume24h: 4980241,
    change24h: 0.45,
    description: 'GateToken is the native token of Gate.io exchange.',
    website: 'https://www.gate.io',
    pros: ['Exchange backing', 'Trading benefits', 'Established platform'],
    cons: ['Centralized', 'Exchange dependent', 'Regulatory risks'],
    reviews: [
      {
        id: '61',
        author: 'GateUser',
        rating: 3,
        date: '2023-11-22',
        comment: 'Good for Gate.io users.',
        verified: true,
      },
    ],
  },
  {
    id: 'bonk',
    name: 'Bonk',
    symbol: 'BONK',
    rank: 60,
    logo: 'https://s2.coinmarketcap.com/static/img/coins/64x64/23095.png',
    trustScore: 6.6,
    price: 0.00000001195,
    marketCap: 807888933,
    volume24h: 80420992,
    change24h: 0.78,
    description: 'Bonk is a Solana-based meme coin.',
    website: 'https://bonkcoin.com',
    pros: ['Solana ecosystem', 'Strong community', 'High liquidity'],
    cons: ['Meme coin', 'No utility', 'Highly speculative'],
    reviews: [
      {
        id: '62',
        author: 'BONKHolder',
        rating: 2,
        date: '2023-11-21',
        comment: 'Fun but risky.',
        verified: false,
      },
    ],
  },
  {
    id: 'pancakeswap',
    name: 'PancakeSwap',
    symbol: 'CAKE',
    rank: 61,
    logo: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7186.png',
    trustScore: 7.8,
    price: 2.34,
    marketCap: 791052578,
    volume24h: 51379010,
    change24h: 0.87,
    description:
      'PancakeSwap is the leading decentralized exchange on BNB Chain.',
    website: 'https://pancakeswap.finance',
    pros: [
      'Leading BSC DEX',
      'High liquidity',
      'Multiple products',
      'Active development',
    ],
    cons: ['BSC dependent', 'Competition', 'Token inflation'],
    reviews: [
      {
        id: '63',
        author: 'CAKEUser',
        rating: 4,
        date: '2023-11-20',
        comment: 'Best BSC DEX.',
        verified: true,
      },
    ],
  },
  {
    id: 'jupiter',
    name: 'Jupiter',
    symbol: 'JUP',
    rank: 62,
    logo: 'https://s2.coinmarketcap.com/static/img/coins/64x64/29210.png',
    trustScore: 7.7,
    price: 0.2498,
    marketCap: 783720953,
    volume24h: 25531747,
    change24h: 1.72,
    description: 'Jupiter is the key liquidity aggregator for Solana.',
    website: 'https://jup.ag',
    pros: ['Solana DEX', 'Best execution', 'Growing adoption', 'User friendly'],
    cons: ['Solana dependent', 'Competition', 'Newer token'],
    reviews: [
      {
        id: '64',
        author: 'JUPUser',
        rating: 4,
        date: '2023-11-19',
        comment: 'Best Solana DEX.',
        verified: true,
      },
    ],
  },
  {
    id: 'story',
    name: 'Story',
    symbol: 'IP',
    rank: 63,
    logo: 'https://s2.coinmarketcap.com/static/img/coins/64x64/35626.png',
    trustScore: 7.3,
    price: 2.34,
    marketCap: 779188790,
    volume24h: 45870090,
    change24h: 1.62,
    description: 'Story Protocol is a blockchain for intellectual property.',
    website: 'https://story.foundation',
    pros: ['IP focus', 'Unique use case', 'Growing interest'],
    cons: ['Newer project', 'Unproven model', 'Adoption challenges'],
    reviews: [
      {
        id: '65',
        author: 'IPUser',
        rating: 3,
        date: '2023-11-18',
        comment: 'Interesting IP concept.',
        verified: false,
      },
    ],
  },
  {
    id: 'pudgy-penguins',
    name: 'Pudgy Penguins',
    symbol: 'PENGU',
    rank: 64,
    logo: 'https://s2.coinmarketcap.com/static/img/coins/64x64/34466.png',
    trustScore: 6.9,
    price: 0.00001194,
    marketCap: 750743553,
    volume24h: 147855987,
    change24h: 1.67,
    description: 'Pudgy Penguins is an NFT collection token.',
    website: 'https://pudgypenguins.com',
    pros: ['Strong NFT brand', 'Community', 'Merchandise'],
    cons: ['NFT dependent', 'Speculative', 'Limited utility'],
    reviews: [
      {
        id: '66',
        author: 'PENGUHolder',
        rating: 3,
        date: '2023-11-17',
        comment: 'Fun NFT project.',
        verified: false,
      },
    ],
  },
  {
    id: 'myx-finance',
    name: 'MYX Finance',
    symbol: 'MYX',
    rank: 65,
    logo: 'https://s2.coinmarketcap.com/static/img/coins/64x64/36410.png',
    trustScore: 7.2,
    price: 3.35,
    marketCap: 741703433,
    volume24h: 40934340,
    change24h: 3.47,
    description: 'MYX Finance is a decentralized perpetual exchange.',
    website: 'https://myx.finance',
    pros: ['Perpetuals focus', 'Growing volume', 'Multi-chain'],
    cons: ['Newer protocol', 'Competition', 'Regulatory risk'],
    reviews: [
      {
        id: '67',
        author: 'MYXTrader',
        rating: 3,
        date: '2023-11-16',
        comment: 'Good perps platform.',
        verified: true,
      },
    ],
  },
  {
    id: 'spx6900',
    name: 'SPX6900',
    symbol: 'SPX',
    rank: 66,
    logo: 'https://s2.coinmarketcap.com/static/img/coins/64x64/28081.png',
    trustScore: 6.5,
    price: 0.6943,
    marketCap: 646460456,
    volume24h: 21542002,
    change24h: 1.48,
    description: 'SPX6900 is a meme coin.',
    website: 'https://spx6900.com',
    pros: ['Meme community', 'High liquidity'],
    cons: ['No utility', 'Speculative', 'Meme volatility'],
    reviews: [
      {
        id: '68',
        author: 'SPXTrader',
        rating: 2,
        date: '2023-11-15',
        comment: 'Pure meme speculation.',
        verified: false,
      },
    ],
  },
  {
    id: 'aerodrome-finance',
    name: 'Aerodrome Finance',
    symbol: 'AERO',
    rank: 67,
    logo: 'https://s2.coinmarketcap.com/static/img/coins/64x64/29270.png',
    trustScore: 7.6,
    price: 0.7088,
    marketCap: 641401045,
    volume24h: 48976671,
    change24h: 5.61,
    description: 'Aerodrome is a next-generation AMM on Base.',
    website: 'https://aerodrome.finance',
    pros: ['Base ecosystem', 've(3,3) model', 'Growing TVL', 'Incentives'],
    cons: ['Newer protocol', 'Base dependent', 'Competition'],
    reviews: [
      {
        id: '69',
        author: 'AEROUser',
        rating: 4,
        date: '2023-11-14',
        comment: 'Best Base DEX.',
        verified: true,
      },
    ],
  },
  {
    id: 'nexo',
    name: 'Nexo',
    symbol: 'NEXO',
    rank: 68,
    logo: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2694.png',
    trustScore: 7.5,
    price: 0.9712,
    marketCap: 627590569,
    volume24h: 13858603,
    change24h: 2.1,
    description:
      'Nexo is a regulated financial institution for digital assets.',
    website: 'https://nexo.io',
    pros: ['Regulated', 'Lending platform', 'Insurance', 'Dividends'],
    cons: ['Centralized', 'Regulatory dependent', 'Platform risk'],
    reviews: [
      {
        id: '70',
        author: 'NEXOUser',
        rating: 4,
        date: '2023-11-13',
        comment: 'Good lending platform.',
        verified: true,
      },
    ],
  },
  {
    id: 'optimism',
    name: 'Optimism',
    symbol: 'OP',
    rank: 69,
    logo: 'https://s2.coinmarketcap.com/static/img/coins/64x64/11840.png',
    trustScore: 8.0,
    price: 0.3237,
    marketCap: 614018510,
    volume24h: 72854989,
    change24h: 0.23,
    description:
      'Optimism is a layer-2 scaling solution for Ethereum using optimistic rollups.',
    website: 'https://optimism.io',
    pros: ['Ethereum L2', 'Low fees', 'EVM compatible', 'Strong ecosystem'],
    cons: ['Centralized sequencer', 'Competition', 'Withdrawal delays'],
    reviews: [
      {
        id: '71',
        author: 'OPUser',
        rating: 4,
        date: '2023-11-12',
        comment: 'Great L2 solution.',
        verified: true,
      },
    ],
  },
  {
    id: 'virtuals-protocol',
    name: 'Virtuals Protocol',
    symbol: 'VIRTUAL',
    rank: 70,
    logo: 'https://s2.coinmarketcap.com/static/img/coins/64x64/29420.png',
    trustScore: 7.1,
    price: 0.9368,
    marketCap: 614637465,
    volume24h: 141198616,
    change24h: 3.56,
    description: 'Virtuals Protocol is an AI agent protocol.',
    website: 'https://virtuals.io',
    pros: ['AI focus', 'Growing interest', 'Unique concept'],
    cons: ['Newer project', 'Unproven', 'Speculative'],
    reviews: [
      {
        id: '72',
        author: 'VIRTUALUser',
        rating: 3,
        date: '2023-11-11',
        comment: 'Interesting AI project.',
        verified: false,
      },
    ],
  },
  {
    id: 'dash',
    name: 'Dash',
    symbol: 'DASH',
    rank: 71,
    logo: 'https://s2.coinmarketcap.com/static/img/coins/64x64/131.png',
    trustScore: 7.6,
    price: 49.4,
    marketCap: 617914623,
    volume24h: 149658016,
    change24h: 1.92,
    description:
      'Dash is a privacy-focused cryptocurrency with instant transactions.',
    website: 'https://dash.org',
    pros: [
      'Fast transactions',
      'Privacy features',
      'Masternode system',
      'Treasury',
    ],
    cons: ['Lower adoption', 'Competition', 'Regulatory concerns'],
    reviews: [
      {
        id: '73',
        author: 'DASHUser',
        rating: 4,
        date: '2023-11-10',
        comment: 'Fast and private.',
        verified: true,
      },
    ],
  },
  {
    id: 'immutable',
    name: 'Immutable',
    symbol: 'IMX',
    rank: 72,
    logo: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10603.png',
    trustScore: 7.8,
    price: 0.3025,
    marketCap: 601700190,
    volume24h: 21357116,
    change24h: 3.3,
    description:
      'Immutable is a layer-2 scaling solution for NFTs on Ethereum.',
    website: 'https://immutable.com',
    pros: [
      'NFT focus',
      'Zero gas fees',
      'Gaming partnerships',
      'Ethereum security',
    ],
    cons: ['NFT dependent', 'Competition', 'Market cycles'],
    reviews: [
      {
        id: '74',
        author: 'IMXUser',
        rating: 4,
        date: '2023-11-09',
        comment: 'Best for NFT gaming.',
        verified: true,
      },
    ],
  },
  {
    id: 'curve-dao',
    name: 'Curve DAO Token',
    symbol: 'CRV',
    rank: 73,
    logo: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6538.png',
    trustScore: 8.1,
    price: 0.4169,
    marketCap: 591974409,
    volume24h: 127998674,
    change24h: 5.18,
    description:
      'Curve is a decentralized exchange optimized for stablecoin trading.',
    website: 'https://curve.fi',
    pros: ['Stablecoin DEX', 'Low slippage', 've tokenomics', 'DeFi staple'],
    cons: ['Complex UI', 'Hack history', 'Competition'],
    reviews: [
      {
        id: '75',
        author: 'CRVUser',
        rating: 4,
        date: '2023-11-08',
        comment: 'Best for stablecoins.',
        verified: true,
      },
    ],
  },
  {
    id: 'injective',
    name: 'Injective',
    symbol: 'INJ',
    rank: 74,
    logo: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7226.png',
    trustScore: 7.9,
    price: 5.88,
    marketCap: 588079498,
    volume24h: 60959604,
    change24h: 1.55,
    description: 'Injective is a blockchain built for finance.',
    website: 'https://injective.com',
    pros: ['DeFi focus', 'Fast finality', 'Cross-chain', 'Growing ecosystem'],
    cons: ['Smaller ecosystem', 'Competition', 'Adoption challenges'],
    reviews: [
      {
        id: '76',
        author: 'INJUser',
        rating: 4,
        date: '2023-11-07',
        comment: 'Great DeFi chain.',
        verified: true,
      },
    ],
  },
  {
    id: 'fetch-ai',
    name: 'Artificial Superintelligence Alliance',
    symbol: 'FET',
    rank: 75,
    logo: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3773.png',
    trustScore: 7.7,
    price: 0.2523,
    marketCap: 583559326,
    volume24h: 86525388,
    change24h: 4.37,
    description:
      'Fetch.ai is building an AI-powered decentralized digital economy.',
    website: 'https://fetch.ai',
    pros: ['AI focus', 'Unique use case', 'Growing interest', 'Strong team'],
    cons: ['Complex technology', 'Adoption challenges', 'Competition'],
    reviews: [
      {
        id: '77',
        author: 'FETUser',
        rating: 4,
        date: '2023-11-06',
        comment: 'Interesting AI blockchain.',
        verified: true,
      },
    ],
  },
  {
    id: 'starknet',
    name: 'Starknet',
    symbol: 'STRK',
    rank: 76,
    logo: 'https://s2.coinmarketcap.com/static/img/coins/64x64/22691.png',
    trustScore: 7.8,
    price: 0.1195,
    marketCap: 573970199,
    volume24h: 69748775,
    change24h: 5.16,
    description: 'Starknet is a validity rollup layer-2 for Ethereum.',
    website: 'https://starknet.io',
    pros: ['ZK technology', 'Ethereum L2', 'Cairo language', 'Strong team'],
    cons: ['Complex technology', 'Developer learning curve', 'Competition'],
    reviews: [
      {
        id: '78',
        author: 'STRKDev',
        rating: 4,
        date: '2023-11-05',
        comment: 'Powerful ZK L2.',
        verified: true,
      },
    ],
  },
  {
    id: 'stacks',
    name: 'Stacks',
    symbol: 'STX',
    rank: 77,
    logo: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4847.png',
    trustScore: 7.7,
    price: 0.3124,
    marketCap: 567015519,
    volume24h: 12834898,
    change24h: 0.91,
    description:
      'Stacks brings smart contracts and decentralized apps to Bitcoin.',
    website: 'https://stacks.co',
    pros: [
      'Bitcoin layer',
      'Smart contracts',
      'Bitcoin security',
      'Growing DeFi',
    ],
    cons: ['Complex technology', 'Slower than other L1s', 'Adoption'],
    reviews: [
      {
        id: '79',
        author: 'STXUser',
        rating: 4,
        date: '2023-11-04',
        comment: 'Bitcoin DeFi is coming.',
        verified: true,
      },
    ],
  },
  {
    id: 'lido-dao',
    name: 'Lido DAO',
    symbol: 'LDO',
    rank: 78,
    logo: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8000.png',
    trustScore: 8.2,
    price: 0.634,
    marketCap: 565609935,
    volume24h: 57213172,
    change24h: 1.27,
    description:
      'Lido is a liquid staking solution for Ethereum and other PoS chains.',
    website: 'https://lido.fi',
    pros: [
      'Liquid staking leader',
      'High TVL',
      'Multiple chains',
      'Strong governance',
    ],
    cons: ['Centralization concerns', 'Regulatory risk', 'Competition'],
    reviews: [
      {
        id: '80',
        author: 'LDOUser',
        rating: 4,
        date: '2023-11-03',
        comment: 'Best liquid staking.',
        verified: true,
      },
    ],
  },
  {
    id: 'celestia',
    name: 'Celestia',
    symbol: 'TIA',
    rank: 79,
    logo: 'https://s2.coinmarketcap.com/static/img/coins/64x64/22861.png',
    trustScore: 7.8,
    price: 0.6316,
    marketCap: 536709484,
    volume24h: 64514189,
    change24h: 0.88,
    description:
      'Celestia is a modular blockchain network for scalable data availability.',
    website: 'https://celestia.org',
    pros: [
      'Modular approach',
      'Data availability',
      'Innovative',
      'Growing interest',
    ],
    cons: ['Newer platform', 'Complex concept', 'Unproven at scale'],
    reviews: [
      {
        id: '81',
        author: 'TIAUser',
        rating: 4,
        date: '2023-11-02',
        comment: 'Modular future.',
        verified: true,
      },
    ],
  },
  {
    id: 'tezos',
    name: 'Tezos',
    symbol: 'XTZ',
    rank: 80,
    logo: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2011.png',
    trustScore: 7.8,
    price: 0.4995,
    marketCap: 533336422,
    volume24h: 22367414,
    change24h: 0.23,
    description:
      'Tezos is a self-amending blockchain with on-chain governance.',
    website: 'https://tezos.com',
    pros: [
      'On-chain governance',
      'Formal verification',
      'Energy efficient',
      'NFT adoption',
    ],
    cons: ['Lower DeFi adoption', 'Slower development', 'Competition'],
    reviews: [
      {
        id: '82',
        author: 'XTZHolder',
        rating: 4,
        date: '2023-11-01',
        comment: 'Solid governance model.',
        verified: true,
      },
    ],
  },
  {
    id: 'telcoin',
    name: 'Telcoin',
    symbol: 'TEL',
    rank: 81,
    logo: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2394.png',
    trustScore: 7.3,
    price: 0.005845,
    marketCap: 531941327,
    volume24h: 4219128,
    change24h: 0.87,
    description: 'Telcoin is a cryptocurrency designed for remittances.',
    website: 'https://telcoin.org',
    pros: [
      'Remittance focus',
      'Telecom partnerships',
      'Real utility',
      'Mobile-first',
    ],
    cons: ['Niche market', 'Adoption challenges', 'Competition'],
    reviews: [
      {
        id: '83',
        author: 'TELUser',
        rating: 3,
        date: '2023-10-31',
        comment: 'Good for remittances.',
        verified: true,
      },
    ],
  },
  {
    id: 'morpho',
    name: 'Morpho',
    symbol: 'MORPHO',
    rank: 82,
    logo: 'https://s2.coinmarketcap.com/static/img/coins/64x64/34104.png',
    trustScore: 7.9,
    price: 1.44,
    marketCap: 521572117,
    volume24h: 35028885,
    change24h: 0.87,
    description: 'Morpho is a lending protocol optimizer.',
    website: 'https://morpho.org',
    pros: [
      'Lending optimization',
      'Better rates',
      'DeFi integration',
      'Innovation',
    ],
    cons: ['Newer protocol', 'Complex mechanism', 'Smart contract risk'],
    reviews: [
      {
        id: '84',
        author: 'MORPHOUser',
        rating: 4,
        date: '2023-10-30',
        comment: 'Better lending rates.',
        verified: true,
      },
    ],
  },
  {
    id: 'the-graph',
    name: 'The Graph',
    symbol: 'GRT',
    rank: 83,
    logo: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6719.png',
    trustScore: 8.0,
    price: 0.04835,
    marketCap: 513428320,
    volume24h: 26656946,
    change24h: 3.13,
    description:
      'The Graph is an indexing protocol for querying blockchain data.',
    website: 'https://thegraph.com',
    pros: [
      'Essential infrastructure',
      'Wide adoption',
      'Decentralized indexing',
      'Growing usage',
    ],
    cons: ['Token utility questions', 'Competition', 'Complex economics'],
    reviews: [
      {
        id: '85',
        author: 'GRTUser',
        rating: 4,
        date: '2023-10-29',
        comment: 'Critical DeFi infrastructure.',
        verified: true,
      },
    ],
  },
  {
    id: 'ether-fi',
    name: 'ether.fi',
    symbol: 'ETHFI',
    rank: 84,
    logo: 'https://s2.coinmarketcap.com/static/img/coins/64x64/29814.png',
    trustScore: 7.7,
    price: 0.8192,
    marketCap: 498550143,
    volume24h: 42491668,
    change24h: 2.26,
    description:
      'ether.fi is a decentralized, non-custodial liquid staking protocol.',
    website: 'https://ether.fi',
    pros: ['Liquid staking', 'Non-custodial', 'Growing TVL', 'Restaking'],
    cons: ['Newer protocol', 'Competition', 'Smart contract risk'],
    reviews: [
      {
        id: '86',
        author: 'ETHFIUser',
        rating: 4,
        date: '2023-10-28',
        comment: 'Good staking option.',
        verified: true,
      },
    ],
  },
  {
    id: 'kaia',
    name: 'Kaia',
    symbol: 'KAIA',
    rank: 85,
    logo: 'https://s2.coinmarketcap.com/static/img/coins/64x64/32880.png',
    trustScore: 7.4,
    price: 0.08044,
    marketCap: 497498284,
    volume24h: 9458575,
    change24h: 0.4,
    description:
      'Kaia is a blockchain platform (merger of Klaytn and Finschia).',
    website: 'https://kaia.io',
    pros: ['Merger synergies', 'Asian focus', 'Enterprise adoption'],
    cons: ['Merger integration', 'Competition', 'Regional focus'],
    reviews: [
      {
        id: '87',
        author: 'KAIAUser',
        rating: 3,
        date: '2023-10-27',
        comment: 'Interesting merger.',
        verified: true,
      },
    ],
  },
  {
    id: 'ab',
    name: 'AB',
    symbol: 'AB',
    rank: 86,
    logo: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3871.png',
    trustScore: 7.0,
    price: 0.005392,
    marketCap: 484419886,
    volume24h: 15974378,
    change24h: 3.19,
    description:
      'AB (Newton) is a blockchain infrastructure for community economy.',
    website: 'https://newtonproject.org',
    pros: ['Community focus', 'Infrastructure', 'Asian market'],
    cons: ['Lower awareness', 'Adoption challenges', 'Competition'],
    reviews: [
      {
        id: '88',
        author: 'ABUser',
        rating: 3,
        date: '2023-10-26',
        comment: 'Interesting community project.',
        verified: false,
      },
    ],
  },
  {
    id: 'floki',
    name: 'FLOKI',
    symbol: 'FLOKI',
    rank: 87,
    logo: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10804.png',
    trustScore: 6.7,
    price: 0.00004871,
    marketCap: 464719853,
    volume24h: 47520434,
    change24h: 1.24,
    description: "Floki is a meme coin inspired by Elon Musk's dog.",
    website: 'https://floki.com',
    pros: [
      'Strong community',
      'Marketing',
      'Growing ecosystem',
      'Utility development',
    ],
    cons: ['Meme coin', 'Speculative', 'High volatility'],
    reviews: [
      {
        id: '89',
        author: 'FLOKIHolder',
        rating: 3,
        date: '2023-10-25',
        comment: 'Fun but risky meme coin.',
        verified: false,
      },
    ],
  },
]

export const exchanges: Exchange[] = [
  {
    id: 'binance',
    name: 'Binance',
    rank: 1,
    logo: 'https://s2.coinmarketcap.com/static/img/exchanges/64x64/270.png',
    trustScore: 9.2,
    tradingVolume: 15208560070,
    supportedCoins: 608,
    tradingFee: '0.1%',
    withdrawalFee: 'Varies by coin',
    description:
      "Binance is the world's largest cryptocurrency exchange by trading volume, offering a comprehensive suite of trading products and services.",
    website: 'https://www.binance.com',
    features: [
      'Spot trading',
      'Futures',
      'Staking',
      'NFT marketplace',
      'Launchpad',
      'P2P trading',
    ],
    pros: [
      'Highest liquidity',
      'Wide coin selection',
      'Low fees',
      'Advanced trading features',
      'Mobile app',
    ],
    cons: [
      'Regulatory challenges',
      'Complex for beginners',
      'Customer support issues',
      'Not available in all regions',
    ],
    reviews: [
      {
        id: '13',
        author: 'ProTrader',
        rating: 5,
        date: '2024-01-15',
        comment: 'Best exchange for serious traders. Unmatched liquidity.',
        verified: true,
      },
      {
        id: '14',
        author: 'CryptoNewbie',
        rating: 3,
        date: '2024-01-14',
        comment: 'Overwhelming at first but powerful once you learn it.',
        verified: true,
      },
    ],
  },
  {
    id: 'coinbase',
    name: 'Coinbase Exchange',
    rank: 2,
    logo: 'https://s2.coinmarketcap.com/static/img/exchanges/64x64/89.png',
    trustScore: 9.0,
    tradingVolume: 2392285189,
    supportedCoins: 353,
    tradingFee: '0.5%',
    withdrawalFee: 'Varies by coin',
    description:
      'Coinbase is a publicly-traded US-based cryptocurrency exchange known for its user-friendly interface and regulatory compliance.',
    website: 'https://www.coinbase.com',
    features: [
      'Spot trading',
      'Staking',
      'NFTs',
      'Learning rewards',
      'Coinbase Card',
      'Advanced trading',
    ],
    pros: [
      'User-friendly',
      'Regulated and insured',
      'Strong security',
      'Educational resources',
      'Fiat on-ramps',
    ],
    cons: [
      'Higher fees',
      'Limited coin selection vs competitors',
      'Customer support delays',
      'Occasional outages',
    ],
    reviews: [
      {
        id: '15',
        author: 'BeginnerInvestor',
        rating: 5,
        date: '2024-01-13',
        comment: 'Perfect for getting started. Easy to use and trustworthy.',
        verified: true,
      },
      {
        id: '16',
        author: 'FeeConscious',
        rating: 3,
        date: '2024-01-12',
        comment: 'Great platform but fees add up quickly.',
        verified: true,
      },
    ],
  },
  {
    id: 'upbit',
    name: 'Upbit',
    rank: 3,
    logo: 'https://s2.coinmarketcap.com/static/img/exchanges/64x64/351.png',
    trustScore: 8.6,
    tradingVolume: 1393944480,
    supportedCoins: 301,
    tradingFee: '0.05%',
    withdrawalFee: 'Varies by coin',
    description:
      "Upbit is South Korea's largest cryptocurrency exchange, offering a wide range of trading pairs.",
    website: 'https://upbit.com',
    features: ['Spot trading', 'KRW pairs', 'Mobile app', 'API trading'],
    pros: [
      'Largest Korean exchange',
      'High liquidity',
      'Wide coin selection',
      'Strong security',
    ],
    cons: ['Korea-focused', 'Limited international access', 'KRW only'],
    reviews: [
      {
        id: '90',
        author: 'KoreanTrader',
        rating: 5,
        date: '2024-01-10',
        comment: 'Best exchange in Korea.',
        verified: true,
      },
    ],
  },
  {
    id: 'okx',
    name: 'OKX',
    rank: 4,
    logo: 'https://s2.coinmarketcap.com/static/img/exchanges/64x64/294.png',
    trustScore: 8.4,
    tradingVolume: 2341660111,
    supportedCoins: 358,
    tradingFee: '0.1%',
    withdrawalFee: 'Varies by coin',
    description:
      'OKX is a comprehensive cryptocurrency exchange offering spot, derivatives, and DeFi services.',
    website: 'https://www.okx.com',
    features: [
      'Spot trading',
      'Futures',
      'Options',
      'DeFi',
      'NFT marketplace',
      'Web3 wallet',
    ],
    pros: [
      'Wide product range',
      'Competitive fees',
      'Good liquidity',
      'Web3 integration',
    ],
    cons: [
      'Complex for beginners',
      'Regional restrictions',
      'Customer support issues',
    ],
    reviews: [
      {
        id: '19',
        author: 'DiverseTrader',
        rating: 4,
        date: '2024-01-09',
        comment: 'Great all-in-one platform for various crypto activities.',
        verified: true,
      },
    ],
  },
  {
    id: 'bybit',
    name: 'Bybit',
    rank: 5,
    logo: 'https://s2.coinmarketcap.com/static/img/exchanges/64x64/521.png',
    trustScore: 8.5,
    tradingVolume: 2784934261,
    supportedCoins: 715,
    tradingFee: '0.1%',
    withdrawalFee: 'Varies by coin',
    description:
      'Bybit is a derivatives-focused cryptocurrency exchange popular among traders for its advanced trading tools.',
    website: 'https://www.bybit.com',
    features: [
      'Derivatives',
      'Spot trading',
      'Copy trading',
      'Launchpad',
      'Earn products',
      'NFTs',
    ],
    pros: [
      'Excellent for derivatives',
      'High leverage options',
      'Good liquidity',
      'User-friendly interface',
    ],
    cons: [
      'Less regulated',
      'Primarily derivatives-focused',
      'Not available in US',
      'Newer platform',
    ],
    reviews: [
      {
        id: '18',
        author: 'FuturesTrader',
        rating: 5,
        date: '2024-01-10',
        comment: 'Best platform for futures trading. Clean interface.',
        verified: true,
      },
    ],
  },
  {
    id: 'bitget',
    name: 'Bitget',
    rank: 6,
    logo: 'https://s2.coinmarketcap.com/static/img/exchanges/64x64/513.png',
    trustScore: 8.3,
    tradingVolume: 1884632350,
    supportedCoins: 737,
    tradingFee: '0.1%',
    withdrawalFee: 'Varies by coin',
    description:
      'Bitget is a cryptocurrency exchange specializing in derivatives and copy trading.',
    website: 'https://www.bitget.com',
    features: ['Spot trading', 'Futures', 'Copy trading', 'Launchpad', 'Earn'],
    pros: [
      'Copy trading leader',
      'Wide coin selection',
      'Competitive fees',
      'Growing platform',
    ],
    cons: ['Newer platform', 'Less regulated', 'Regional restrictions'],
    reviews: [
      {
        id: '91',
        author: 'CopyTrader',
        rating: 4,
        date: '2024-01-09',
        comment: 'Best copy trading features.',
        verified: true,
      },
    ],
  },
  {
    id: 'gate',
    name: 'Gate.io',
    rank: 7,
    logo: 'https://s2.coinmarketcap.com/static/img/exchanges/64x64/302.png',
    trustScore: 8.0,
    tradingVolume: 2542406952,
    supportedCoins: 2054,
    tradingFee: '0.15%',
    withdrawalFee: 'Varies by coin',
    description:
      'Gate.io offers one of the largest selections of cryptocurrencies and trading pairs in the industry.',
    website: 'https://www.gate.io',
    features: [
      'Spot trading',
      'Futures',
      'Copy trading',
      'Startup IEO',
      'Lending',
      'NFTs',
    ],
    pros: [
      'Massive coin selection',
      'Early token listings',
      'Competitive fees',
      'Multiple products',
    ],
    cons: [
      'Overwhelming interface',
      'Less regulated',
      'Customer support',
      'Lower liquidity on some pairs',
    ],
    reviews: [
      {
        id: '23',
        author: 'TokenCollector',
        rating: 4,
        date: '2024-01-05',
        comment: 'Incredible selection of coins. Can find anything here.',
        verified: true,
      },
    ],
  },
  {
    id: 'kucoin',
    name: 'KuCoin',
    rank: 8,
    logo: 'https://s2.coinmarketcap.com/static/img/exchanges/64x64/311.png',
    trustScore: 8.2,
    tradingVolume: 3635173883,
    supportedCoins: 1043,
    tradingFee: '0.1%',
    withdrawalFee: 'Varies by coin',
    description:
      'KuCoin is known as "The People\'s Exchange" offering a vast selection of cryptocurrencies and tokens.',
    website: 'https://www.kucoin.com',
    features: [
      'Spot trading',
      'Futures',
      'Margin',
      'P2P',
      'Staking',
      'Trading bots',
    ],
    pros: [
      'Huge coin selection',
      'Early access to new tokens',
      'Trading bots',
      'Competitive fees',
    ],
    cons: [
      'Less regulated',
      'Occasional liquidity issues',
      'Customer support',
      'Security concerns',
    ],
    reviews: [
      {
        id: '20',
        author: 'AltcoinHunter',
        rating: 4,
        date: '2024-01-08',
        comment: 'Best for finding new altcoins early.',
        verified: true,
      },
    ],
  },
  {
    id: 'mexc',
    name: 'MEXC',
    rank: 9,
    logo: 'https://s2.coinmarketcap.com/static/img/exchanges/64x64/544.png',
    trustScore: 7.9,
    tradingVolume: 3726043879,
    supportedCoins: 1994,
    tradingFee: '0.2%',
    withdrawalFee: 'Varies by coin',
    description:
      'MEXC is a global cryptocurrency exchange with a focus on emerging tokens and high trading volume.',
    website: 'https://www.mexc.com',
    features: ['Spot trading', 'Futures', 'Margin', 'Launchpad', 'Staking'],
    pros: [
      'Huge token selection',
      'Early listings',
      'High volume',
      'Multiple products',
    ],
    cons: ['Less regulated', 'Customer support', 'Complex interface'],
    reviews: [
      {
        id: '92',
        author: 'NewTokenHunter',
        rating: 4,
        date: '2024-01-07',
        comment: 'Great for new token launches.',
        verified: true,
      },
    ],
  },
  {
    id: 'htx',
    name: 'HTX',
    rank: 10,
    logo: 'https://s2.coinmarketcap.com/static/img/exchanges/64x64/102.png',
    trustScore: 7.9,
    tradingVolume: 3832768283,
    supportedCoins: 709,
    tradingFee: '0.2%',
    withdrawalFee: 'Varies by coin',
    description:
      'HTX (formerly Huobi) is a global cryptocurrency exchange offering comprehensive trading services.',
    website: 'https://www.htx.com',
    features: ['Spot trading', 'Futures', 'Margin', 'Staking', 'DeFi', 'Earn'],
    pros: [
      'Established platform',
      'Wide coin selection',
      'Global presence',
      'Multiple products',
    ],
    cons: [
      'Regulatory challenges',
      'Declining volume',
      'Customer support',
      'Regional restrictions',
    ],
    reviews: [
      {
        id: '24',
        author: 'GlobalTrader',
        rating: 3,
        date: '2024-01-04',
        comment: 'Solid platform but facing regulatory headwinds.',
        verified: true,
      },
    ],
  },
  {
    id: 'crypto-com',
    name: 'Crypto.com Exchange',
    rank: 11,
    logo: 'https://s2.coinmarketcap.com/static/img/exchanges/64x64/1149.png',
    trustScore: 8.4,
    tradingVolume: 3274986947,
    supportedCoins: 425,
    tradingFee: '0.075%',
    withdrawalFee: 'Varies by coin',
    description:
      'Crypto.com Exchange offers a comprehensive trading platform with competitive fees and deep liquidity.',
    website: 'https://crypto.com',
    features: [
      'Spot trading',
      'Derivatives',
      'Margin',
      'Staking',
      'DeFi Wallet',
    ],
    pros: ['Low fees', 'Good liquidity', 'CRO benefits', 'Mobile app'],
    cons: [
      'Complex fee structure',
      'Regional restrictions',
      'Customer support',
    ],
    reviews: [
      {
        id: '93',
        author: 'CROHolder',
        rating: 4,
        date: '2024-01-06',
        comment: 'Great benefits with CRO staking.',
        verified: true,
      },
    ],
  },
  {
    id: 'bitfinex',
    name: 'Bitfinex',
    rank: 12,
    logo: 'https://s2.coinmarketcap.com/static/img/exchanges/64x64/37.png',
    trustScore: 7.8,
    tradingVolume: 203889025,
    supportedCoins: 110,
    tradingFee: '0.1%',
    withdrawalFee: 'Varies by coin',
    description:
      'Bitfinex is a veteran cryptocurrency exchange offering advanced trading features and high liquidity.',
    website: 'https://www.bitfinex.com',
    features: [
      'Spot trading',
      'Margin trading',
      'Derivatives',
      'Lending',
      'OTC',
      'Staking',
    ],
    pros: [
      'High liquidity',
      'Advanced features',
      'Margin trading',
      'Professional tools',
    ],
    cons: [
      'Past security issues',
      'Not available in US',
      'Complex interface',
      'Controversial history',
    ],
    reviews: [
      {
        id: '22',
        author: 'VeteranTrader',
        rating: 4,
        date: '2024-01-06',
        comment: 'Great for professional traders despite past issues.',
        verified: true,
      },
    ],
  },
  {
    id: 'bingx',
    name: 'BingX',
    rank: 13,
    logo: 'https://s2.coinmarketcap.com/static/img/exchanges/64x64/1064.png',
    trustScore: 8.1,
    tradingVolume: 1561244384,
    supportedCoins: 1064,
    tradingFee: '0.1%',
    withdrawalFee: 'Varies by coin',
    description:
      'BingX is a social trading platform with copy trading and derivatives.',
    website: 'https://bingx.com',
    features: ['Copy trading', 'Spot', 'Futures', 'Grid trading'],
    pros: ['Copy trading', 'User-friendly', 'Wide selection'],
    cons: ['Newer platform', 'Less regulated'],
    reviews: [
      {
        id: '94',
        author: 'SocialTrader',
        rating: 4,
        date: '2024-01-05',
        comment: 'Good copy trading platform.',
        verified: true,
      },
    ],
  },
  {
    id: 'kraken',
    name: 'Kraken',
    rank: 14,
    logo: 'https://s2.coinmarketcap.com/static/img/exchanges/64x64/24.png',
    trustScore: 8.9,
    tradingVolume: 1196474706,
    supportedCoins: 691,
    tradingFee: '0.16%',
    withdrawalFee: 'Varies by coin',
    description:
      'Kraken is a veteran cryptocurrency exchange known for its security, low fees, and comprehensive trading options.',
    website: 'https://www.kraken.com',
    features: [
      'Spot trading',
      'Futures',
      'Margin trading',
      'Staking',
      'OTC desk',
      'Banking services',
    ],
    pros: [
      'Strong security record',
      'Low fees',
      'Good customer support',
      'Regulated',
      'Advanced features',
    ],
    cons: [
      'Complex interface',
      'Slower fiat deposits',
      'Limited payment methods',
      'Verification process',
    ],
    reviews: [
      {
        id: '17',
        author: 'SecurityFirst',
        rating: 5,
        date: '2024-01-11',
        comment: "Most secure exchange I've used. Never been hacked.",
        verified: true,
      },
    ],
  },
  {
    id: 'binance-tr',
    name: 'Binance TR',
    rank: 15,
    logo: 'https://s2.coinmarketcap.com/static/img/exchanges/64x64/1375.png',
    trustScore: 8.2,
    tradingVolume: 156850737,
    supportedCoins: 306,
    tradingFee: '0.1%',
    withdrawalFee: 'Varies by coin',
    description:
      'Binance TR is the Turkish version of Binance, offering TRY trading pairs.',
    website: 'https://www.trbinance.com',
    features: ['Spot trading', 'TRY pairs', 'Staking'],
    pros: ['Turkish lira support', 'Binance backing', 'Local compliance'],
    cons: ['Turkey only', 'Limited features vs global Binance'],
    reviews: [
      {
        id: '95',
        author: 'TurkishUser',
        rating: 4,
        date: '2024-01-04',
        comment: 'Best for Turkish traders.',
        verified: true,
      },
    ],
  },
  {
    id: 'bitmart',
    name: 'BitMart',
    rank: 16,
    logo: 'https://s2.coinmarketcap.com/static/img/exchanges/64x64/406.png',
    trustScore: 7.7,
    tradingVolume: 3267771261,
    supportedCoins: 1094,
    tradingFee: '0.25%',
    withdrawalFee: 'Varies by coin',
    description:
      'BitMart is a global cryptocurrency exchange with a wide selection of altcoins.',
    website: 'https://www.bitmart.com',
    features: ['Spot trading', 'Futures', 'Margin', 'Staking'],
    pros: ['Wide coin selection', 'Multiple features', 'Competitive fees'],
    cons: ['Past security breach', 'Customer support', 'Less regulated'],
    reviews: [
      {
        id: '96',
        author: 'AltcoinTrader',
        rating: 3,
        date: '2024-01-03',
        comment: 'Good selection but had security issues.',
        verified: true,
      },
    ],
  },
  {
    id: 'lbank',
    name: 'LBank',
    rank: 17,
    logo: 'https://s2.coinmarketcap.com/static/img/exchanges/64x64/333.png',
    trustScore: 7.6,
    tradingVolume: 4086543112,
    supportedCoins: 1027,
    tradingFee: '0.1%',
    withdrawalFee: 'Varies by coin',
    description:
      'LBank is a global cryptocurrency exchange with focus on emerging markets.',
    website: 'https://www.lbank.com',
    features: ['Spot trading', 'Futures', 'IEO', 'Staking'],
    pros: ['Wide coin selection', 'Early listings', 'Multiple markets'],
    cons: ['Less regulated', 'Customer support', 'Lower liquidity'],
    reviews: [
      {
        id: '97',
        author: 'EmergingMarkets',
        rating: 3,
        date: '2024-01-02',
        comment: 'Good for new tokens.',
        verified: false,
      },
    ],
  },
  {
    id: 'bitstamp',
    name: 'Bitstamp by Robinhood',
    rank: 18,
    logo: 'https://s2.coinmarketcap.com/static/img/exchanges/64x64/70.png',
    trustScore: 8.7,
    tradingVolume: 538568593,
    supportedCoins: 118,
    tradingFee: '0.5%',
    withdrawalFee: 'Varies by coin',
    description:
      'Bitstamp is one of the oldest cryptocurrency exchanges, now owned by Robinhood, known for reliability and security.',
    website: 'https://www.bitstamp.net',
    features: ['Spot trading', 'Staking', 'Instant buy', 'API'],
    pros: ['Long track record', 'Regulated', 'Robinhood backing', 'Reliable'],
    cons: ['Higher fees', 'Limited coins', 'Basic features'],
    reviews: [
      {
        id: '98',
        author: 'OldSchool',
        rating: 4,
        date: '2024-01-01',
        comment: 'Reliable and trustworthy.',
        verified: true,
      },
    ],
  },
  {
    id: 'bithumb',
    name: 'Bithumb',
    rank: 19,
    logo: 'https://s2.coinmarketcap.com/static/img/exchanges/64x64/200.png',
    trustScore: 8.0,
    tradingVolume: 606299944,
    supportedCoins: 446,
    tradingFee: '0.25%',
    withdrawalFee: 'Varies by coin',
    description:
      "Bithumb is one of South Korea's largest cryptocurrency exchanges.",
    website: 'https://www.bithumb.com',
    features: ['Spot trading', 'KRW pairs', 'Mobile app'],
    pros: ['Major Korean exchange', 'High volume', 'Wide selection'],
    cons: ['Korea focused', 'Past security issues', 'KRW only'],
    reviews: [
      {
        id: '99',
        author: 'KoreanUser',
        rating: 4,
        date: '2023-12-31',
        comment: 'Popular in Korea.',
        verified: true,
      },
    ],
  },
  {
    id: 'xt',
    name: 'XT.COM',
    rank: 20,
    logo: 'https://s2.coinmarketcap.com/static/img/exchanges/64x64/525.png',
    trustScore: 7.8,
    tradingVolume: 2598414252,
    supportedCoins: 1098,
    tradingFee: '0.2%',
    withdrawalFee: 'Varies by coin',
    description:
      'XT.COM is a global cryptocurrency exchange with a wide range of trading pairs.',
    website: 'https://www.xt.com',
    features: ['Spot trading', 'Futures', 'Launchpad', 'Staking'],
    pros: ['Wide selection', 'Multiple features', 'Growing platform'],
    cons: ['Less known', 'Customer support', 'Lower liquidity'],
    reviews: [
      {
        id: '100',
        author: 'XTUser',
        rating: 3,
        date: '2023-12-30',
        comment: 'Decent platform.',
        verified: false,
      },
    ],
  },
  {
    id: 'gemini',
    name: 'Gemini',
    rank: 21,
    logo: 'https://s2.coinmarketcap.com/static/img/exchanges/64x64/151.png',
    trustScore: 8.8,
    tradingVolume: 170821097,
    supportedCoins: 78,
    tradingFee: '0.35%',
    withdrawalFee: 'Free (10 per month)',
    description:
      'Gemini is a regulated US cryptocurrency exchange founded by the Winklevoss twins, emphasizing security and compliance.',
    website: 'https://www.gemini.com',
    features: [
      'Spot trading',
      'Staking',
      'Gemini Earn',
      'Credit card',
      'Custody services',
      'ActiveTrader',
    ],
    pros: [
      'Highly regulated',
      'Strong security',
      'Free withdrawals',
      'Insurance coverage',
      'Good for institutions',
    ],
    cons: [
      'Higher fees',
      'Limited coin selection',
      'US-focused',
      'Smaller trading volume',
    ],
    reviews: [
      {
        id: '21',
        author: 'RegulationMatters',
        rating: 5,
        date: '2024-01-07',
        comment: 'Most trustworthy US exchange. Worth the higher fees.',
        verified: true,
      },
    ],
  },
]
